module.exports = __webpack_public_path__ + "img/kir.429d5e68.jpg";